import { useCallback, useState } from 'react';

export const useLinksViewModel = () => {
  const [isEditLinkOpen, setIsEditLinkOpen] = useState(false);
  const openEditLinkPopup = useCallback(() => {
    setIsViewLinkOpen(false);
    setIsEditLinkOpen(true);
  }, []);
  const closeEditLinkPopup = useCallback(() => {
    setIsEditLinkOpen(false);
  }, []);

  const [isViewLinkOpen, setIsViewLinkOpen] = useState(false);
  const openViewLinkPopup = useCallback(() => {
    setIsEditLinkOpen(false);
    setIsViewLinkOpen(true);
  }, []);
  const closeViewLinkPopup = useCallback(() => {
    setIsViewLinkOpen(false);
  }, []);

  return {
    isEditLinkOpen,
    openEditLinkPopup,
    closeEditLinkPopup,
    isViewLinkOpen,
    openViewLinkPopup,
    closeViewLinkPopup,
  };
};
